import Base from './condition-base'
import renderFields from './push-event.pug'

export default class PushEvent extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
